var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"jwt-play"},[_c('div',{staticClass:"jwt-play_play-btn",class:{
			'jwt-play_play-btn--disable': _vm.disable,
		}},[_vm._t("default",function(){return [_c('FontAwesomeIcon',{attrs:{"icon":"play","size":"2x"}})]}),_c(_setup.ProviderIcon,{staticClass:"jwt-play_icon",attrs:{"providerId":_setup.providersByShortName['jwt']?.packageId,"size":"small"}})],2),_c('span',{staticClass:"jwt-play_text"},[_vm._v(_vm._s(_vm.$tc('WEBAPP_FREE_STREAM')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }